module.exports = {
	"pl": {
		"translation": {
			"moreInformation": "więcej informacji",
			"close": "Zamknij",
			"uploader": {
				"overlay": {
					"title": "Przeciągnij i upuść",
					"subtitle": "Twoje pliki"
				},
				"form": {
					"dragAndDrop": "Przeciągnij i upuść",
					"or": "lub",
					"chooseFiles": "Wybierz pliki",
					"from": "z komputera"
				},
				"errors": {
					"file_size": "przekracza maksymalna rozmiar pliku {{size}}.",
					"file_type": "{{type}} jest niepoprawnym typem pliku."
				},
				"status": {
					"idle": "w oczekiwaniu",
					"processing": "przetwarzanie",
					"uploading": "wgrywanie",
					"success": "pomyślnie zakończono",
					"cancel": "anuluj",
					"error": "błąd",
					"none": ""
				}
			},
			"actions": {
				"delete": "Usuń",
				"apply": "Zastosuj",
				"cancel": "Anuluj"
			},
			"dateInput": {
				"choose": "Wybierz Datę",
				"clear": "Wyczyść Datę"
			},
			"daterange": {
				"last_7_days": "Ostanie 7 Dni",
				"last_30_days": "Ostanie 30 Dni",
				"this_month": "Ten miesiąc",
				"last_month": "Poprzedni miesiąc",
				"start_date": "Data Początkowa",
				"end_date": "Data Końcowa",
				"not_set": "Nie ustawiony"
			},
			"comment": {
				"delete": "Usuń komentarz"
			},
			"pagination": {
				"intro": "Paginacja, obecnie na stronie {{currentPage}}",
				"page": "Strona {{pageNumber}}",
				"ellipsis": "Więcej stron",
				"prev": "Poprzednia strona",
				"next": "Następna strona"
			},
			"formElement": {
				"optional": "(opcjonalny)",
				"required": "(wymagane)"
			},
			"prevNextArrowButton": {
				"arrowup": "w górę",
				"arrowdown": "w dół",
				"escape": "escape"
			},
			"externalLink": {
				"view": "zobacz"
			},
			"collapsible": {
				"ariaText": "zwiń sekcję"
			}
		}
	}
};